let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5fAr6")).then(() => parcelRequire('jlZwt'));